import { Box, CircularProgress } from '@material-ui/core';
import {
  useParams, Redirect,
} from "react-router-dom";
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../reduxhooks';
import { signIn } from '../redux/AccountRedux';
import { fetchMarketplaceOrder, openOverlayCreateMeasWithInitialization as openUniversalSizeOverlay } from '../redux/UIOverlayUniversalSizeRedux';
import { sendWebsiteLivestreamMessage } from '../telegrambotevents';

export default function PageCreatePersonalSize() {
  let { orderIdFormat } = useParams<{ orderIdFormat: string }>();
  const orderCreationDateTime = orderIdFormat.slice(0, 24);
  const orderUserSub = orderIdFormat.slice(25);
  const dispatch = useAppDispatch();
  const marketplaceOrder = useAppSelector(state => state.overlayUniversalSize.marketplaceOrder);

  // 01. Auto fetch the order as reference
  useEffect(() => {

    // START HOTJAR RECORDING
    (window as any).hj('event', 'start_hotjar_rec');
    (window as any).hj('event', 'event_recording_sizing');
    console.log("START-HOTJAR-REC");
    sendWebsiteLivestreamMessage('[HOTJAR REC - UX] STARTED - MEAS KIT SCAN (MARKETPLACE)');

    dispatch(fetchMarketplaceOrder(orderIdFormat));
  }, [orderIdFormat]);

  // 03. If the user is signed in and has purchased, we open personal size overlay and redirect to shop page
  if (marketplaceOrder) {
    dispatch(openUniversalSizeOverlay({ productOnUser: undefined, flowVariant: 'measKitScanMarketplace' }));

    return (<Redirect to={"/shop"} />);
  }

  // 04. If the user is signed in but has not purchased, we just return null / a blank page
  return (
    <Box style={{
      width: '100%',
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <CircularProgress />
    </Box>
  );
}